module.exports = __webpack_public_path__ + "img/bank-mark-as-reviewed.a1dfc8d7.svg";